export var dataTableV2HeaderHeight = 'var(--_1hmse0v1-2-0-1)';
export var dataTableV2HeaderRowIndexVar = 'var(--_1hmse0v0-2-0-1)';